import { post } from "@app/common/api";
import type { LoginMethod } from "@app/common/types/providerTypes";

export const getLoginMethods = ({
  email,
}: {
  email: string;
}): Promise<LoginMethod[]> => {
  return post("/login/methods", { identifier: email });
};
